import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "className", "colSpan", "rowSpan", "textAlign", "ellipsis", "loading"];
import React from 'react';
import cx from 'classnames';
import Box from '../../Box';
import Skeleton from '../../Skeleton';
import Text from '../../Text';
import styles from './index.module.scss';

var Td = function Td(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      colSpan = _ref.colSpan,
      rowSpan = _ref.rowSpan,
      textAlign = _ref.textAlign,
      ellipsis = _ref.ellipsis,
      loading = _ref.loading,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classNames = (_classNames = {}, _classNames[styles.root] = true, _classNames[styles.ellipsis] = ellipsis, _classNames[styles.loading] = loading, _classNames);
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "td",
    py: 5,
    px: 6,
    textAlign: textAlign,
    colSpan: colSpan,
    rowSpan: rowSpan,
    className: cx(classNames, className)
  }, rest), loading ? /*#__PURE__*/React.createElement(Skeleton, null) : /*#__PURE__*/React.createElement(Text, {
    size: "Caption1",
    fontFamily: "system"
  }, children));
};

export default Td;